import { DmsLocations } from "../../auth/Auth";
import * as Yup from "yup";
import { DmsSetupDefaultType } from "../Integration/DmsSetup";

export interface SetupProfile {
  id: string;
  shopifyUrl?: string;
  shopifyAccessToken?: string;
  dmsPaymentMethodId?: string;
  customerCategoryId?: string;
  siteName?: string;
  dmsLocations?: DmsLocations[];
  syncExisting: boolean;
  IsUpdateCustomerAndPaymentOnly?: boolean;
  isDefaultShippingOnly?: boolean;
  setupDefaultType?: DmsSetupDefaultType;
  setupDefaultValue1?: string;
  setupDefaultValue2?: string;
}
export interface DmsPaymentMethod {
  paymentTypeID: string;
  description: string;
  isActive?: boolean;
  cashType?: boolean;
  creditDebitGift?: boolean;
  creditCard?: boolean;
  giftCard?: boolean;
  openCashDrawer?: boolean;
  isDebit?: boolean;
  gLType?: string;
  remotePay?: boolean;
}
export interface CustomerCategory {
  customerCategoryId: string;
  name: string;
}
export interface MiscInventoryData {
  inventoryMiscellaneousId: string | null;
  manufacturerId: string | null;
}
export const SetupProfileInitialValues: SetupProfile = {
  id: "",
  shopifyUrl: "",
  shopifyAccessToken: "",
  siteName: "",
  dmsPaymentMethodId: "",
  customerCategoryId: "",
  syncExisting: false,
  IsUpdateCustomerAndPaymentOnly: false,
};
export const SetupProfileValidationSchema = Yup.object().shape({
  shopifyUrl: Yup.string()
    .matches(
      /^(https:\/\/[a-zA-Z0-9][a-zA-Z0-9-]*\.myshopify\.com)(?!\/)$/,
      "Please enter a valid URL with this pattern https://XXXXXXXXX.myshopify.com"
    )
    .required("shopUrl is a required field"),
  // shopifyAccessToken: Yup.string().required(
  //   "shopAccessToken is a required field"
  // ),
  //dmsLocations: Yup.array().min(1, "At least one DMS location is required"),
});
